import { createFileRoute } from '@tanstack/react-router';
import { IconIdBadge2 } from '@tabler/icons-react';
import { ResourceListPage } from '@/shared/components/ResourceListPage';
import { QuickCreateButton, type FieldDef } from '@/shared/components/QuickCreateButton';
import type { Denormalized } from '@/shared/api/jsonapi/parser';

interface ErpRole extends Denormalized { type: 'erp-roles'; name?: string; description?: string; isManagerial?: boolean }

const FIELDS: FieldDef[] = [
  { name: 'name', label: 'Nome', required: true },
  { name: 'description', label: 'Descrizione', kind: 'textarea' },
  { name: 'isManagerial', label: 'Ruolo manageriale', kind: 'boolean', defaultValue: false },
];

export const Route = createFileRoute('/_app/workforce/roles')({ component: RolesPage });

function RolesPage() {
  return (
    <ResourceListPage<ErpRole>
      title=""
      type="erp-roles"
      description="Mansioni HR assegnabili ai dipendenti (es. Sviluppatore, Project Manager). Diverse dai ruoli di accesso/permessi."
      columns={[
        {
          accessorKey: 'name',
          header: 'Ruolo',
          Cell: ({ cell, row }) => cell.getValue<string>() || `(senza nome · ${String(row.original.id).slice(0, 8)})`,
        },
        { accessorKey: 'description', header: 'Descrizione' },
        { accessorKey: 'isManagerial', header: 'Manageriale', size: 110, Cell: ({ cell }) => (cell.getValue<boolean>() ? '✓' : '—') },
      ]}
      searchField="name"
      emptyMessage="Nessun ruolo HR"
      emptyDescription="Crea il primo ruolo con il bottone «Nuovo ruolo HR» nella toolbar."
      emptyIcon={IconIdBadge2}
      editFields={FIELDS}
      editTitle="Modifica ruolo HR"
      enableDelete
      getRowLabel={(r) => r.name ?? r.id}
      toolbarRight={<QuickCreateButton type="erp-roles" title="Nuovo ruolo HR" fields={FIELDS} />}
    />
  );
}
